import {useEffect} from "react";
import {debugLog} from "../Utils/LogUtils";

export default function useUpdateDependant1BasedOnBene(state) {
    useEffect(() => {
        debugLog("useUpdateDependant1BasedOnBeneBirthdate");
        if (!state.beneficiary.birthdate) { return; }
        if (!state.knowYourClient.beneficiaryIsADependant) { return; } //If the beneficiary is not a dependant, we don't need to update the dependant birthdate
        if (state.application.masterApplicationId) { return; } //If the enrolment is a secondary enrolment in a family enrolment, we don't update the dependant.

        state.setDependant({
            ...state.dependant,
            birthdate: state.beneficiary.birthdate,
            name: `${state.beneficiary.firstName} ${state.beneficiary.lastName}`
        });
    }, [state.beneficiary.birthdate, state.beneficiary.firstName, state.beneficiary.lastName, state.knowYourClient.beneficiaryIsADependant]);
}